import { Box, Text } from '@factorialco/deprecated-design-system'
import type {
  DataTableBooleanFilter,
  DataTableDateFilter,
  DataTableEntityFilter,
  DataTableFilter,
  DataTableIntegerFilter,
  DataTableStringFilter,
} from 'generated/resources/datatable.graphql'

import { FILTER_OPERATIONS } from 'modules/core/components/DataTable/constants'
import type { Filter } from 'modules/core/components/DataTable/types'
import Select from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

type Props<T> = {
  filter: Filter<T>['filter']
  category: Filter<T>['category']
  onCategoryChange: (category: Filter<T>['category']) => void
}

function getLabel<T>(category: DataTableFilter<T>['categories'][number]) {
  switch (category.operation) {
    case FILTER_OPERATIONS.EQUAL:
      return i18n.t('data_table.filters.operations.eq')
    case FILTER_OPERATIONS.NOT_EQUAL:
      return i18n.t('data_table.filters.operations.not')
    case FILTER_OPERATIONS.BETWEEN:
      return i18n.t('data_table.filters.operations.between')
    case FILTER_OPERATIONS.IN:
      return i18n.t('data_table.filters.operations.in')
    case FILTER_OPERATIONS.CONTAINS:
      return i18n.t('data_table.filters.operations.contains')
  }
}

function Header<T>({ filter, category, onCategoryChange }: Props<T>) {
  if (filter.categories.length <= 1) return null

  const options = filter.categories.map((category) => ({
    label: getLabel(category) as string,
    value: category.operation,
  }))

  const onChange = (value: string) => {
    // NOTE: In need of this magic because of https://github.com/microsoft/TypeScript/issues/33591
    // Add more filter types here as needed
    const categories = filter.categories as Array<
      | DataTableDateFilter<T>['categories'][number]
      | DataTableStringFilter<T>['categories'][number]
      | DataTableIntegerFilter<T>['categories'][number]
      | DataTableBooleanFilter<T>['categories'][number]
      | DataTableEntityFilter<T>['categories'][number]
    >
    const category = categories.find((category) => category.operation === value)
    if (category) onCategoryChange(category)
  }

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      paddingLeft="s16"
      gap="s8"
    >
      <Text.Normal size="200">{filter.title}</Text.Normal>
      <Box width="s140">
        <Select options={options} onChange={onChange} value={category.operation} hideBorder />
      </Box>
    </Box>
  )
}

export default Header
